// extracted by mini-css-extract-plugin
export default {"wrapper":"AddMembers_wrapper__P+UKZ","title":"AddMembers_title__PcXlp"};